import axios from "axios";

const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rg_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const ws = localStorage.getItem("rg_workspace");
  if (ws) config.headers["X-Workspace-Id"] = ws;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const detail = error.response?.data?.detail;
    if (error.response?.status === 403 && typeof detail === "string" && detail.includes("Not a member")) {
      localStorage.removeItem("rg_workspace");
      window.location.href = "/dashboard";
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  }
  if (detail.msg) return detail.msg;
  if (typeof detail.message === "string") return detail.message;
  return String(detail);
}
